import { useEffect } from 'react';
export const useBeforeUnload = () => {
    useEffect(() => {
        window.onbeforeunload = () => true;
        return () => {
            window.onbeforeunload = null;
        };
    }, []);
};
